(() => {
  const $cartModal = document.getElementById("cart-modal");
  if (!$cartModal) return;
  const $cartCounter = document.querySelector(".header__cart-counter");
  let cartCounterValue = Number($cartCounter?.textContent);

  const initializeSwiper = () => {
    const $cartSwiper = $cartModal.querySelector(".swiper");
    if (!$cartSwiper) return;
    new Swiper($cartSwiper, {
      slidesPerView: "auto",
      grabCursor: true,
    });
  };

  initializeSwiper();

  const modalClose = () => {
    document
      .querySelectorAll("button[data-action-cart='close']")
      ?.forEach((close) => {
        close.addEventListener("click", () => {
          $cartModal?.classList.remove("active");
        });
      });
  };
  modalClose();

  // const modalOpen = () => {
  //   document
  //     .querySelectorAll("button[data-action-cart='open']")
  //     ?.forEach((open) => {
  //       open.addEventListener("click", () => {
  //         $cartModal?.classList.add("active");
  //       });
  //     });
  // };
  // modalOpen();

  const changeCartCounter = () => {
    fetch(`${Shopify.routes.root}cart.js`)
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        document
          .querySelectorAll(".header__cart-counter")
          .forEach((counter) => {
            if (cart["item_count"] > 0) {
              counter.textContent = cart["item_count"];
              counter.classList.add("active");
            } else {
              counter.textContent = "";
              counter.classList.remove("active");
            }
          });
      });
  };

  const removeFromCart = () => {
    document.querySelectorAll(".remove-from-cart")?.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.dataset.key && btn.dataset.qty) {
          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify({
              id: btn.dataset.key,
              quantity: Number(btn.dataset.qty),
            }),
          }).then((response) => {
            if (response.status === 200) window.refreshCartModal();
          });
        }
      });
    });
  };
  removeFromCart();

  window.refreshCartModal = () => {
    $cartModal.style.pointerEvents = "none";
    return fetch(`${Shopify.routes.root}cart?view=ajax`)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        $cartModal.innerHTML = result;
        initializeSwiper();
        $cartModal.classList.add("active");
        modalOpen();
        modalClose();
        removeFromCart();
        changeCartCounter();
        $cartModal.style.pointerEvents = "auto";
      });
  };

  if (!cartCounterValue) return;

  const observer = new MutationObserver(() => {
    const cartCounterValueNew = Number(
      document.querySelector(".header__cart-counter")?.textContent
    );
    if (cartCounterValueNew !== cartCounterValue) {
      cartCounterValue = cartCounterValueNew;
      refreshCartModal();
    }
  });
  observer.observe($cartCounter, { attributes: true });
})();

(() => {
  const $swiperInstagram = document.querySelector(".theme-instagram .swiper");
  if (!$swiperInstagram) return;
  const params = {
    speed: 800,
    slidesPerView: "auto",
    loop: true,
    grabCursor: true,
  };
  const timer = Number($swiperInstagram.dataset.timer) * 1000;
  if (timer > 0) {
    params.autoplay = true;
    params.delay = timer;
  }
  new Swiper($swiperInstagram, params);
})();

(() => {
  document
    .querySelectorAll(".global-banner .swiper")
    .forEach(($bannerSwiper) => {
      const params = {
        slidesPerView: 1,
        grabCursor: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      };
      const timer = Number($bannerSwiper.dataset.timer);
      if (timer && timer > 0)
        params.autoplay = {
          delay: timer * 1000,
          disableOnInteraction: false,
        };
      new Swiper($bannerSwiper, params);
    });
})();

(() => {
  document.querySelectorAll(".global-collection-feature").forEach((parent) => {
    const collectionFeatureSwipers = parent.querySelectorAll(
      ".global-collection-feature__swiper"
    );
    collectionFeatureSwipers?.forEach((swiper) => {
      const params = {
        speed: 800,
        slidesPerView: "auto",
        loop: true,
        grabCursor: true,
      };
      new Swiper(swiper, params);
    });

    const collectionFeatureSwiperTabs = parent.querySelector(".swiper-tabs");
    if (collectionFeatureSwiperTabs) {
      const params = {
        slidesPerView: "auto",
        grabCursor: true,
      };
      new Swiper(collectionFeatureSwiperTabs, params);
    }

    const collectionFeatureBtn = parent.querySelectorAll(
      ".global-collection-feature__btn"
    );
    collectionFeatureBtn?.forEach((btn) => {
      btn.addEventListener("click", () => {
        collectionFeatureBtn?.forEach((otherBtn) => {
          if (otherBtn !== btn) {
            otherBtn.classList.remove("active");
          }
        });
        collectionFeatureSwipers?.forEach((swiper) => {
          if (swiper.id !== btn.dataset.swiper) {
            swiper.classList.add("tw-hidden");
          } else {
            swiper.classList.remove("tw-hidden");
            btn.classList.add("active");
          }
        });
      });
    });
  });
})();

(() => {
  const swiperImageSliders = document.querySelectorAll(
    ".global-image-slider .swiper"
  );
  swiperImageSliders?.forEach(($swiperImageSlider) => {
    const params = {
      slidesPerView: "auto",
      grabCursor: true,
    };
    new Swiper($swiperImageSlider, params);
  });
})();

(() => {
  const productAccordions = document.querySelectorAll(".product-accordion");
  productAccordions.forEach(($accordion) => {
    const $btn = $accordion.querySelector("button");
    const $content = $accordion.querySelector("div");
    if ($btn && $content) {
      $btn.addEventListener("click", () => {
        $accordion.classList.toggle("active");
        productAccordions.forEach(($otherAccordion) => {
          if ($otherAccordion !== $accordion) {
            $otherAccordion.classList.remove("active");
          }
        });
      });
    }
  });
})();

(() => {
  const $productSwiper = document.querySelector(".product__swiper");
  if (!$productSwiper) return;
  const params = {
    slidesPerView: "auto",
    grabCursor: true,
  };
  new Swiper($productSwiper, params);
})();
